import permissions from 'api/Apollo/permissions';
import { METHOD, PATH } from 'api/control/control-api';
import { normalizeResponse, useControlProxy } from 'api/control/useControlProxy';

export default function useValidateEvent(options = {}) {
  const [call, response] = useControlProxy({
    permission: permissions.deliverEvents,
    ...options,
  });

  const executeValidateEvent = ({ clusterId, inputEvent }) => {
    return call({
      path: PATH.ValidateEvent,
      method: METHOD.POST,
      body: { inputEvent },
      clusterId,
    });
  };

  return [executeValidateEvent, normalizeResponse(response)];
}
